import { useMemo } from 'react'

import { CreatorPermission } from '@api'
import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $ableToReassignSales } from '@/models/feature-flags.ts'
import { ONLYFANS_PREFIX } from '@/modules/creators/views/consts'
import { handleError } from '@/utils/error'

import { teamService } from '../service/team-service'

export function useTeamPermissions() {
  const ableToReassignSales = useUnit($ableToReassignSales)
  const { data: allPermissions, ...rest } = useQuery({
    queryKey: ['team', 'role', 'permissions', ableToReassignSales],
    queryFn: teamService.getAllRolePermissions,
    initialData: [],
    select: (data) =>
      ableToReassignSales
        ? data
        : data.filter(
            (permission) =>
              permission.value !== CreatorPermission.REASSIGN_SALES,
          ),
    onError: (error) =>
      handleError(error, 'Failed to get team permissions', rest.refetch),
  })

  const ofPermissions = useMemo(() => {
    if (allPermissions) {
      return allPermissions
        .filter((permission) => permission.value?.startsWith(ONLYFANS_PREFIX))
        .sort((a, b) => {
          if (!a.value || !b.value) return -1

          if (a.value === CreatorPermission.OF_ADMIN) return -1
          if (b.value === CreatorPermission.OF_ADMIN) return 1

          return a.value.localeCompare(b.value)
        })
    }

    return []
  }, [allPermissions])

  const generalPermissions = useMemo(() => {
    if (allPermissions) {
      return allPermissions.filter(
        (permission) =>
          !permission.value?.startsWith(ONLYFANS_PREFIX) &&
          permission.value !== 'ACCESS_ONLYFANS_PROFILE',
      )
    }

    return []
  }, [allPermissions])

  const accessOnlyFansProfilePermission = useMemo(() => {
    return allPermissions?.find(
      (permission) => permission.value === 'ACCESS_ONLYFANS_PROFILE',
    )
  }, [allPermissions])

  return {
    allPermissions,
    generalPermissions,
    accessOnlyFansProfilePermission,
    ofPermissions,
    ...rest,
  }
}
